import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import translate from '@i18n'
import SecondaryCTAButton from '@components/Buttons/SecondaryCTAButton'

import AnswerFeedback from './AnswerFeedback'

import type { AnswerType } from '../types'

const StyledAnswerFooter = styled.div`
  ${({
    theme: {
      spacing: { spacing24, spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing24};
    margin-top: ${spacing24};

    ${mobileCSS(css`
      gap: ${spacing16};
      margin-top: ${spacing16};
    `)}
  `}
`

const StyledDisclaimer = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: bodyCopyXXSmallCSS },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    ${bodyCopyXXSmallCSS};
    color: ${textWeak};
  `}
`

type AnswerFooterProps = {
  answer: AnswerType
  hasSources: boolean
  onSourcesClick: () => void
}

const AnswerFooter: FunctionComponent<AnswerFooterProps> = ({
  answer,
  hasSources,
  onSourcesClick,
}) => {
  return (
    <StyledAnswerFooter>
      <StyledDisclaimer>
        {translate('aiSearch.answerMessage.disclaimer')}
      </StyledDisclaimer>
      <AnswerFeedback answer={answer}>
        {hasSources && (
          <SecondaryCTAButton
            onClick={onSourcesClick}
            size="small"
            colorVariant="black"
            iconName="link"
          >
            {translate('aiSearch.answerMessage.sources')}
          </SecondaryCTAButton>
        )}
      </AnswerFeedback>
    </StyledAnswerFooter>
  )
}

export default AnswerFooter
